import { render, staticRenderFns } from "./checkPwdByMsgDialog.vue?vue&type=template&id=1ccc704a&scoped=true&"
import script from "./checkPwdByMsgDialog.vue?vue&type=script&lang=js&"
export * from "./checkPwdByMsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./checkPwdByMsgDialog.vue?vue&type=style&index=0&id=1ccc704a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc704a",
  null
  
)

export default component.exports